function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { FormattedMessage } from 'react-intl';
import { AppContext } from 'context';
import { getSlug } from 'helpers/urlTools';
import Account from 'modules/Account';
import Button from 'components/Form/Button';
import * as actions from '../../actions';
import * as constants from '../../constants';
import * as selectors from '../../selectors';
import messages from '../../messages';
import ActivePatients from './ActivePatients';
import PendingPatients from './PendingPatients';
var _React_PureComponent;
class PatientsList extends (_React_PureComponent = React.PureComponent) {
    componentDidUpdate(prevProps) {
        const { activeClinicMembership } = this.props;
        const profilesReferenceKey = get(activeClinicMembership, 'clinic.profilesReferenceKey');
        const prevProfilesReferenceKey = get(prevProps.activeClinicMembership, 'clinic.profilesReferenceKey');
        if (prevProfilesReferenceKey !== profilesReferenceKey && profilesReferenceKey) {
            this.onFetchPatients();
        }
    }
    onFetchPatients() {
        const profilesReferenceKey = get(this.props.activeClinicMembership, 'clinic.profilesReferenceKey');
        if (process.env.BROWSER && profilesReferenceKey) {
            this.props.onFetchPatients(this.props.activeClinicMembership);
        }
    }
    renderShowMorButton() {
        const { showMoreButton } = this.props;
        const { activePatientsLength, enrollingPatientLength } = this.state;
        if (!showMoreButton || activePatientsLength + enrollingPatientLength < constants.PATIENTS_LIST_LENGTH) {
            return null;
        }
        const { organizationUID, name } = get(this.props.activeClinicMembership, 'clinic', {});
        const fullPatientsListHref = this.context.getUrl('patients-list', {
            clinicSlug: getSlug(name),
            organizationUID
        });
        return /*#__PURE__*/ _jsx("div", {
            className: "d-flex justify-content-center",
            children: /*#__PURE__*/ _jsx(Button, {
                to: fullPatientsListHref,
                type: "link",
                styleModifier: "primary",
                labelMessage: messages.buttons.showMore,
                className: "btn--sm btn--white",
                onClick: ()=>this.props.onShowMoreButtonClick()
            })
        });
    }
    renderNoFindedResults() {
        const { showNoFindedResults, search } = this.props;
        const { activePatientsLength, enrollingPatientLength } = this.state;
        if (showNoFindedResults && activePatientsLength === 0 && enrollingPatientLength === 0 && !isEmpty(search)) {
            return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.noFindedPatients));
        }
        return null;
    }
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                this.renderNoFindedResults(),
                /*#__PURE__*/ _jsx(PendingPatients, _object_spread_props(_object_spread({}, this.props), {
                    setEnrollingPatientLength: (enrollingPatientLength)=>this.setState({
                            enrollingPatientLength
                        }),
                    maxPatientLength: constants.PATIENTS_LIST_LENGTH
                })),
                /*#__PURE__*/ _jsx(ActivePatients, _object_spread_props(_object_spread({}, this.props), {
                    setActivePatientsLength: (activePatientsLength)=>this.setState({
                            activePatientsLength
                        }),
                    maxPatientLength: constants.PATIENTS_LIST_LENGTH - this.state.enrollingPatientLength
                })),
                this.renderShowMorButton()
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            enrollingPatientLength: 0,
            activePatientsLength: 0
        };
        if (props.isWithoutLoad) {
            return;
        }
        this.onFetchPatients();
    }
}
_define_property(PatientsList, "contextType", AppContext);
_define_property(PatientsList, "propTypes", {
    // Explicit props
    activeClinicMembership: Account.shapes.clinicMembership,
    isWithoutLoad: PropTypes.bool,
    showMoreButton: PropTypes.bool,
    showNoFindedResults: PropTypes.bool,
    // Explicit props
    onShowMoreButtonClick: PropTypes.func,
    // Implicit props
    search: PropTypes.string,
    // Implicit actions
    onFetchPatients: PropTypes.func
});
_define_property(PatientsList, "defaultProps", {
    onShowMoreButtonClick: ()=>{}
});
const mapStateToProps = (state, props)=>({
        search: selectors.searchSelector(props.id)(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onFetchPatients: (clinicMembership)=>Promise.all([
                dispatch(actions.fetchPatients(clinicMembership)),
                dispatch(actions.fetchEnrollingSharingRequests(clinicMembership))
            ])
    });
const ConnectedPatientsList = connect(mapStateToProps, mapDispatchToProps)(PatientsList);
export default ConnectedPatientsList;
